//icons
import { DarkMode, LightMode } from '@styled-icons/material-rounded'
import { Home } from '@styled-icons/entypo'
import { FileEarmarkCode, Star } from '@styled-icons/bootstrap'
import { Backpack } from '@styled-icons/boxicons-solid'
import { Feather, PriceTag } from '@styled-icons/entypo'
import { ChatFill } from '@styled-icons/bootstrap'

import NavMenuLink from './NavMenuLink'

//libs
import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import $ from 'jquery'

const variants = {
	open: {
		opacity: 1,
		x: '0%',
	},
	closed: {
		opacity: 0,
		x: '100%',
	},
}

function NavMenu(props) {
	const [theme, setTheme] = useState('dark')

	useEffect(() => {
		if (theme !== 'dark') {
			return document.querySelector('html').classList.remove('dark')
		}
		return document.querySelector('html').classList.add('dark')
	}, [theme])

	return (
		<motion.aside
			variants={props.animate && variants}
			initial='closed'
			animate={props.isOpen ? 'open' : 'closed'}
			transition={{ duration: 0.5 }}
			className={`${props.className} `}
			id='right-menu'
		>
			<div className='flex flex-col justify-between items-center h-full py-[52px] wrapper'>
				{theme === 'dark' ? (
					<LightMode
						onClick={() =>
							setTheme(theme === 'dark' ? 'light' : 'dark')
						}
						className='w-[30px] h-[30px] p-[5px] fill-dark-300 bg-white rounded-full cursor-pointer'
					/>
				) : (
					<DarkMode
						onClick={() =>
							setTheme(theme === 'dark' ? 'light' : 'dark')
						}
						className='w-[30px] h-[30px] p-[2px] fill-white bg-black rounded-full cursor-pointer'
					/>
				)}
				<div className='flex flex-col gap-[20px] xl:gap-[43px] menu'>
					<NavMenuLink href='#welcome'>
						<Home className={'fill-dark-200 w-[18px] h-[18px]'} />
					</NavMenuLink>
					<NavMenuLink href='#services'>
						<FileEarmarkCode
							className={'fill-dark-200 w-[18px] h-[18px]'}
						/>
					</NavMenuLink>
					<NavMenuLink href='#prices'>
						<PriceTag
							className={'fill-dark-200 w-[18px] h-[18px]'}
						/>
					</NavMenuLink>
					<NavMenuLink href='#recommendations'>
						<Star className={'fill-dark-200 w-[18px] h-[18px]'} />
					</NavMenuLink>
					<NavMenuLink href='#portfolio'>
						<Backpack
							className={'fill-dark-200 w-[18px] h-[18px]'}
						/>
					</NavMenuLink>
					<NavMenuLink href='#blog'>
						<Feather
							className={'fill-dark-200 w-[18px] h-[18px]'}
						/>
					</NavMenuLink>
				</div>
			</div>
		</motion.aside>
	)
}

export default NavMenu
